module.exports = __webpack_public_path__ + "images/liinilaevad/favicon-128x128.png";